// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1___1cd3b332fe7cfefeeb0","cls2":"MultiPaperModal-cls2___3553e1f5c77356604f1 MultiPaperModal-cls1___1cd3b332fe7cfefeeb0"};